import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Paw = (props: Icon): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 16 16"
    style={{ ...style(props.size, props.height), ...props.style }}
    className={props.className}
  >
    <defs>
      <path
        id="paw-a"
        d="M12 11.335c1.16 0 2.23.64 2.937 1.725l1.983 3.046c.739 1.134.461 2.675-.63 3.454a2.34 2.34 0 01-2.427.185l-.389-.193-.118.075c-.36.214-.767.342-1.195.368L12 20c-.486 0-.952-.132-1.356-.373l-.119-.075-.385.192c-.735.37-1.598.34-2.3-.097l-.13-.087c-1.091-.78-1.369-2.32-.63-3.454l1.982-3.045c.706-1.085 1.778-1.726 2.938-1.726zm0 1.333c-.687 0-1.35.397-1.82 1.12l-1.983 3.045c-.351.54-.218 1.28.288 1.643.316.225.711.25 1.058.076l.769-.383a.667.667 0 01.761.119l.086.077a1.318 1.318 0 001.768-.077l.063-.055c.2-.15.47-.177.698-.064l.772.384c.344.173.74.148 1.055-.077.506-.362.64-1.103.288-1.643l-1.983-3.045c-.471-.724-1.134-1.12-1.82-1.12zM6 8.667c.342 0 .624.257.662.589l.005.077v.782A2 2 0 018 12.001v.667a2 2 0 01-4 0v-.667a2 2 0 011.333-1.886v-.782c0-.368.299-.666.667-.666zm12 0c.342 0 .624.257.662.589l.005.077v.782A2 2 0 0120 12.001v.667a2 2 0 01-4 0v-.667a2 2 0 011.333-1.886v-.782c0-.368.299-.666.667-.666zM6 11.335a.666.666 0 00-.667.666v.667a.666.666 0 101.334 0v-.667A.666.666 0 006 11.335zm12 0a.666.666 0 00-.667.666v.667a.666.666 0 101.334 0v-.667a.666.666 0 00-.667-.666zM14.667 4c.342 0 .623.257.662.589l.004.078v.78a2 2 0 011.334 1.886v.668a2 2 0 01-4 0v-.668A2 2 0 0114 5.447v-.78c0-.369.298-.667.667-.667zM9.333 4c.342 0 .624.257.663.589l.004.078v.78a2 2 0 011.333 1.886v.668a2 2 0 01-4 0v-.668a2 2 0 011.333-1.886v-.78c0-.369.3-.667.667-.667zm5.334 2.667a.666.666 0 00-.667.666v.668a.666.666 0 101.333 0v-.668a.666.666 0 00-.666-.666zm-5.334 0a.666.666 0 00-.666.666v.668a.666.666 0 101.333 0v-.668a.666.666 0 00-.667-.666z"
      ></path>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(-4 -4)">
      <mask id="paw-b" fill="#fff">
        <use xlinkHref="#paw-a"></use>
      </mask>
      <g fill={props.color || theme.palette.grey600} mask="url(#paw-b)">
        <path d="M0 0h24v24H0z"></path>
      </g>
    </g>
  </svg>
);
